import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const DemographicsRedux = createActions({
  DemographicsExcelRequest: [''],
  DemographicsExcelSuccess: [''],
  DemographicsExcelError: ['error'],
},
{
  prefix: 'DEMOGRAPHICS_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = DemographicsRedux
export const DemographicsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const DemographicsExcelRequest = state =>
  state.merge({ sending: { fetching: true, error: null } }, d)

const DemographicsExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)

const DemographicsExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DemographicsExcelRequest]: DemographicsExcelRequest,
  [Types.DemographicsExcelSuccess]: DemographicsExcelSuccess,
  [Types.DemographicsExcelError]: DemographicsExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DemographicsRedux.js